import { Directive, HostBinding, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[baseCollapsableContent]',
})
export class BaseCollapsableContentDirective implements OnInit {
  @Input() isInitiallyCollapsed = false;
  @Input() isFullContentArrow = false;

  @HostBinding('class.is-collapsed') isCollapsed: boolean;

  @HostListener('click', ['$event']) onClick(event: Event) {
    const target = event.target as HTMLElement;
    if (
      (!this.isFullContentArrow && target.className.includes('collapsable-header')) ||
      (this.isFullContentArrow && target.className.includes('arrow-bottom'))
    ) {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  ngOnInit() {
    this.isCollapsed = this.isInitiallyCollapsed;
  }
}
